import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  Input,
  DatePicker,
  Button,
  Card,
  Divider,
  Row,
  Col,
  Badge,
  Popconfirm,
  Checkbox,
  ConfigProvider,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "dayjs/locale/bg"; // Import Bulgarian locale
import bgBG from "antd/lib/locale/bg_BG";
import localizedFormat from "dayjs/plugin/localizedFormat";
import reservationsActions from "../../../../redux/reservations/actions";
import CloseButton from "../../../Common/CloseButton/CloseButton";
import "./index.css";

dayjs.extend(localizedFormat);

// Set the locale to Bulgarian
dayjs.locale("bg");

const { createReservationGetTables, editReservation, deleteReservation } =
  reservationsActions;

const EditReservationNewModal = ({ date }) => {
  const dispatch = useDispatch();

  const { freeTables, openEditReservationModal } = useSelector(
    (state) => state.restaurantReservationsReducer
  );

  const { regions } = useSelector((state) => state.restaurantSchemaReducer);

  const increaseGuestCount = () => {
    setGuestCount(guestCount + 1);
  };

  const declineGuestCount = () => {
    let newCount = guestCount - 1;
    if (newCount < 0) {
      newCount = 0;
    }
    setGuestCount(newCount);
  };

  const increaseDuration = () => {
    setDuration(duration + 1);
  };

  const declineDuration = () => {
    let newCount = duration - 1;
    if (newCount < 0) {
      newCount = 0;
    }
    setDuration(newCount);
  };

  const [selectedDate, setSelectedDate] = useState();
  const [selectedHour, setSelectedHour] = useState("");
  const [selectedMins, setSelectedMins] = useState("");
  const [selectedTables, setSelectedTables] = useState([]);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [guestCount, setGuestCount] = useState(1);
  const [duration, setDuration] = useState(1);
  const [note, setNote] = useState("");
  const [deposit, setDeposit] = useState("");
  const [currentRegionKey, setCurrentRegionKey] = useState(
    openEditReservationModal.regionId
  );
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const setToday = () => {
    const today = dayjs();
    setSelectedDate(today);
  };

  const setTomorrow = () => {
    const tomorrow = dayjs().add(1, "day");
    setSelectedDate(tomorrow);
  };

  const hours = [
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
  ];

  const minutes = ["00", "30"];

  const handleSelectHourClick = (hour) => {
    setSelectedHour(hour);
  };

  const handleSelectMinsClick = (mins) => {
    setSelectedMins(mins);
  };

  const handleSelectTablesClick = (table) => {
    setSelectedTables((prevSelectedTables) => {
      // Check if the table is already selected
      if (prevSelectedTables.includes(table)) {
        // If already selected, remove it from the array
        return prevSelectedTables.filter((t) => t !== table);
      } else {
        // If not selected, add it to the array
        return [...prevSelectedTables, table];
      }
    });
  };

  const handleInputNameChange = (e) => {
    setName(e.target.value);
  };

  const handleInputPhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleInputNoteChange = (e) => {
    setNote(e.target.value);
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf("day");
  };

  const closeModal = () => {
    // setSelectedDate(dayjs());
    // setSelectedHour("19");
    // setSelectedMins("00");
    // setSelectedTables([]);
    // setName("");
    // setPhoneNumber("");
    // setGuestCount(1);
    // setDuration(1);
    // setNote("");

    dispatch({
      type: "CLOSE_RESERVATION_EDIT_MODAL",
    });
  };

  const [validate, setValidate] = useState(false);

  const isOnlyIntegers = (str) => {
    if (str.length === 0) {
      return false;
    }
    const integerRegex = /^\d+$/;
    return integerRegex.test(str);
  };

  const handleEditRezervation = () => {
    if (
      name !== "" &&
      phoneNumber !== "" &&
      isOnlyIntegers(phoneNumber) &&
      selectedTables.length > 0
    ) {
      dispatch(
        editReservation({
          guestsCount: guestCount,
          regionId: currentRegionKey,
          duration: duration,
          reservationTime: `${selectedHour}:${selectedMins}:00`,
          reservationDate: selectedDate.format("YYYY-MM-DD"),
          name: name,
          phone: phoneNumber,
          note: note,
          deposit: deposit !== "" ? parseFloat(deposit) : 0,
          organizationId: parseInt(localStorage.getItem("organizationId")),
          TouchSaleTablesIds: selectedTables,
          ReservationId: openEditReservationModal.reservationId,
          date: date,
          status: openEditReservationModal.status,
        })
      );

      setValidate(false);
    } else {
      setValidate(true);
    }
  };

  const checkWhichTablesArePartOfReservation = (table) => {
    return openEditReservationModal.touchSaleTables?.some(
      (defaultTable) => defaultTable.touchSaleTableId === table.touchSaleTableId
    );
  };

  const handleDeleteReservation = () => {
    dispatch(deleteReservation(openEditReservationModal.reservationId));
  };

  useEffect(() => {
    if (selectedDate) {
      dispatch(
        createReservationGetTables({
          organizationId: parseInt(localStorage.getItem("organizationId")),
          regionId: currentRegionKey,
          date: selectedDate.format("YYYY-MM-DD"),
          time: `${selectedHour}:${selectedMins}`,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, selectedHour, selectedMins, currentRegionKey]);

  useEffect(() => {
    if (Object.keys(openEditReservationModal).length > 0) {
      setGuestCount(openEditReservationModal.guestsCount);
      setDuration(openEditReservationModal.duration);
      setSelectedDate(dayjs(openEditReservationModal.reservationDate));
      setSelectedHour(openEditReservationModal.reservationTime.slice(0, 2));
      setSelectedMins(openEditReservationModal.reservationTime.slice(3, 5));
      setName(openEditReservationModal.name);
      setPhoneNumber(openEditReservationModal.phone);
      setNote(openEditReservationModal.note);
      setDeposit(openEditReservationModal.deposit || "");
      setCurrentRegionKey(openEditReservationModal.regionId);
      setSelectedTables(
        openEditReservationModal.touchSaleTables.map(
          (table) => table.touchSaleTableId
        )
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openEditReservationModal]);

  useEffect(() => {
    // Handler to call on window resize
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <ConfigProvider locale={bgBG}>
      <Modal
        closeIcon={<CloseButton />}
        title="Редакция на резервация"
        open={Object.keys(openEditReservationModal).length > 0}
        onOk={handleEditRezervation}
        onCancel={closeModal}
        className="reservation-edit-modal"
        footer={null}
        width={windowSize >= 767 ? "1040px" : "520px"}
      >
        <div className="edit-reservation-modal-main-header-container">
          <div className="edit-reservation-modal-main-header-dates">
            <Button
              size={windowSize <= 767 && "small"}
              onClick={setToday}
              className={`${
                selectedDate?.isSame(dayjs(), "day")
                  ? "edit-reservation-modal-button-border"
                  : ""
              } `}
            >
              Днес
            </Button>
            <Button
              size={windowSize <= 767 && "small"}
              onClick={setTomorrow}
              className={`${
                selectedDate?.isSame(dayjs().add(1, "day"), "day")
                  ? "edit-reservation-modal-button-border"
                  : ""
              } `}
            >
              Утре
            </Button>
            <DatePicker
              className={`edit-reservation-modal-date-picker ${
                !selectedDate?.isSame(dayjs(), "day") &&
                !selectedDate?.isSame(dayjs().add(1, "day"), "day")
                  ? "edit-reservation-modal-button-border edit-reservation-modal-date-picker-text-color"
                  : ""
              }`}
              size={windowSize <= 767 && "small"}
              format="dddd, D MMM"
              onChange={handleDateChange}
              value={selectedDate}
              disabledDate={disabledDate}
              inputReadOnly={true}
            />
          </div>
        </div>
        <div className="edit-reservation-modal-select-time-container">
          <div>
            <Row gutter={16}>
              {hours.slice(0, 6).map((label, index) => (
                <Col key={index} span={windowSize <= 767 ? 3 : 4}>
                  <Button
                    size={windowSize <= 767 && "small"}
                    onClick={() => handleSelectHourClick(label)}
                    className={`${
                      label === selectedHour
                        ? "edit-reservation-modal-button-border"
                        : ""
                    } `}
                  >
                    {label}
                  </Button>
                </Col>
              ))}
            </Row>
            <Row
              gutter={16}
              className="edit-reservation-modal-select-time-second-row"
            >
              {hours.slice(6).map((label, index) => (
                <Col key={index} span={windowSize <= 767 ? 3 : 4}>
                  <Button
                    size={windowSize <= 767 && "small"}
                    onClick={() => handleSelectHourClick(label)}
                    className={`${
                      label === selectedHour
                        ? "edit-reservation-modal-button-border"
                        : ""
                    } `}
                  >
                    {label}
                  </Button>
                </Col>
              ))}
            </Row>
          </div>
          <div>
            <Row gutter={16}>
              {minutes.slice(0, 1).map((label, index) => (
                <Col key={index} span={windowSize <= 767 ? 9 : 10}>
                  <Button
                    size={windowSize <= 767 && "small"}
                    onClick={() => handleSelectMinsClick(label)}
                    className={`${
                      label === selectedMins
                        ? "edit-reservation-modal-button-border"
                        : ""
                    } `}
                  >
                    {label}
                  </Button>
                </Col>
              ))}
            </Row>
            <Row
              gutter={16}
              className="edit-reservation-modal-select-time-second-row"
            >
              {minutes.slice(1).map((label, index) => (
                <Col key={index} span={windowSize <= 767 ? 9 : 10}>
                  <Button
                    size={windowSize <= 767 && "small"}
                    onClick={() => handleSelectMinsClick(label)}
                    className={`${
                      label === selectedMins
                        ? "edit-reservation-modal-button-border"
                        : ""
                    } `}
                  >
                    {label}
                  </Button>
                </Col>
              ))}
            </Row>
          </div>
        </div>
        <Divider />
        <div className="edit-reservation-modal-select-duration-guest-container">
          <div className="edit-reservation-modal-select-duration-guest-secondary-container">
            <span>Места</span>
            <div className="edit-reservation-modal-select-duration-guest-element">
              <Button disabled={guestCount <= 1} onClick={declineGuestCount}>
                -
              </Button>
              {guestCount}

              <Button onClick={increaseGuestCount}>+</Button>
            </div>
          </div>

          <div className="edit-reservation-modal-select-duration-guest-secondary-container">
            <span>Продължителност</span>
            <div className="edit-reservation-modal-select-duration-guest-element">
              <Button disabled={duration <= 1} onClick={declineDuration}>
                -
              </Button>
              {duration}

              <Button onClick={increaseDuration} disabled={duration >= 14}>
                +
              </Button>
            </div>
          </div>
        </div>
        <Divider />
        <div className="reservation-modal-region-grid">
          {regions?.map((region) => (
            <Button
              key={region.key}
              type="default"
              className={`reservation-modal-region-button ${
                currentRegionKey === region.key ? "active" : ""
              }`}
              onClick={() => setCurrentRegionKey(region.key)}
            >
              {region.label}
            </Button>
          ))}
        </div>
        <div className="reservation-modal-tables-grid">
            {freeTables.map((table, index) => (
              <div key={index}>
                <Badge
                  count={table.seatsCount}
                  className="edit-reservation-modal-select-table-card-badge"
                  style={{
                    backgroundColor: `${
                      table.seatsCount === guestCount &&
                      !table.activeReservation
                        ? "#7bb57b"
                        : "rgb(229 229 229)"
                    }`,
                    color: "#000000",
                  }}
                >
                  <Card
                    onClick={() => {
                      if (
                        table.activeReservation === false ||
                        openEditReservationModal.touchSaleTables?.some(
                          (defaultTable) =>
                            defaultTable.touchSaleTableId ===
                            table.touchSaleTableId
                        )
                      ) {
                        handleSelectTablesClick(table.touchSaleTableId);
                      }
                    }}
                    // With this code we check if this tables are part of the Editable Reservation and based ot this we change the color
                    // checkWhichTablesArePartOfReservation()
                    style={{
                      background: `${
                        table.activeReservation === true &&
                        !checkWhichTablesArePartOfReservation(table)
                          ? "#cccaca" // gray
                          : selectedTables.includes(table.touchSaleTableId)
                          ? "#1677ff" // blue
                          : "#e2efd9" // green
                      }`,
                      color: `${
                        selectedTables.includes(table.touchSaleTableId)
                          ? "#ffffff"
                          : ""
                      }`,
                    }}
                    className="edit-reservation-modal-select-table-card"
                    bodyStyle={{
                      padding: "10px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span className="edit-reservation-modal-select-table-card-reservation-times">
                      {table.previousReservation?.slice(0, 5)}
                    </span>
                    <span className="edit-reservation-modal-select-table-card-reservation-name">
                      {table.tableName}
                    </span>
                    <span className="edit-reservation-modal-select-table-card-reservation-times">
                      {!checkWhichTablesArePartOfReservation(table) &&
                        table.nextReservation?.slice(0, 5)}
                    </span>
                  </Card>
                </Badge>
              </div>
            ))}
        </div>
        {validate && selectedTables <= 0 && (
          <p className="edit-reservation-modal-validation-message">
            Моля, изберете маса
          </p>
        )}

        <Divider />
        <div className="edit-reservation-modal-input-main-container">
          <div className="edit-reservation-modal-input-container">
            <span>Име:</span>
            <Input
              className="edit-reservation-modal-input-element"
              allowClear
              placeholder="Иван Иванов"
              value={name}
              onChange={handleInputNameChange}
            />
          </div>
          {validate && name === "" && (
            <p className="edit-reservation-modal-validation-message">
              Моля, въведете име
            </p>
          )}
        </div>

        <div className="edit-reservation-modal-input-main-container">
          <div className="edit-reservation-modal-input-container">
            <span>Телефон:</span>
            <Input
              className="edit-reservation-modal-input-element"
              type="tel"
              allowClear
              placeholder="0899995231"
              value={phoneNumber}
              onChange={handleInputPhoneNumberChange}
            />
          </div>
          {validate && !isOnlyIntegers(phoneNumber) && (
            <p className="edit-reservation-modal-validation-message">
              Моля, въведете телефонен номер
            </p>
          )}
        </div>

        <div className="edit-reservation-modal-input-container">
          <span>Забележка:</span>

          <Input.TextArea
            className="edit-reservation-modal-input-element"
            allowClear
            value={note}
            onChange={handleInputNoteChange}
          />
        </div>

        <div className="edit-reservation-modal-input-container">
          <span>Депозит:</span>
          <Input
            className="edit-reservation-modal-input-element"
            type="number"
            min={0}
            step={0.01}
            allowClear
            placeholder="0.00"
            value={deposit}
            onChange={(e) => setDeposit(e.target.value)}
          />
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "20px",
            justifyContent: "center",
          }}
        >
          <Popconfirm
            title="Сигурни, че искате да изтриете тази резервация?"
            onConfirm={handleDeleteReservation}
            placement="bottom"
            okText="Да"
            cancelText="Не"
          >
            <Button danger>
              <DeleteOutlined />
            </Button>
          </Popconfirm>

          <div>
            {name !== "" &&
            phoneNumber !== "" &&
            isOnlyIntegers(phoneNumber) &&
            selectedTables.length > 0 ? (
              <Popconfirm
                title="Редакция на резервация"
                description={
                  <div className="edit-reservation-popconfirm-container">
                    <p>
                      За:{" "}
                      <b>
                        {dayjs(
                          `${selectedHour}:${selectedMins}-${selectedDate.format(
                            "DD.MM.YYYY"
                          )}`,
                          "HH:mm-DD.MM.YYYY"
                        )
                          .locale("bg") // Set locale to Bulgarian for day names
                          .format("HH:mm DD.MM.YYYY (dddd)")}
                      </b>
                    </p>
                    <p>
                      Маса:{" "}
                      <b>
                        {selectedTables.length > 0
                          ? selectedTables
                              .map((selectedTable) =>
                                freeTables
                                  .filter(
                                    (table) =>
                                      table.touchSaleTableId === selectedTable
                                  )
                                  .map((table) => table.tableName)
                              )
                              .flat()
                              .join(", ")
                          : "-"}
                      </b>
                    </p>

                    <p>
                      Клиент:{" "}
                      <b>
                        {name || ""}, {phoneNumber || ""}
                      </b>
                    </p>

                    <p>
                      Брой хора: <b>{guestCount}</b>
                    </p>
                    <p>
                      Продължителност:{" "}
                      <b>
                        {duration} {duration === 1 ? "час" : "часа"}
                      </b>
                    </p>
                    <Checkbox>Изпрати SMS</Checkbox>
                  </div>
                }
                onConfirm={handleEditRezervation}
                onCancel={() => console.log("Cancelled")}
                okText="Запис"
                cancelText="Отказ"
                okButtonProps={{
                  className:
                    "edit-reservation-popconfirm-custom-confirm-button",
                }}
                cancelButtonProps={{
                  className: "edit-reservation-popconfirm-custom-cancel-button",
                }}
              >
                <Button>Промени</Button>
              </Popconfirm>
            ) : (
              <Button
                onClick={() => {
                  if (
                    name === "" ||
                    phoneNumber === "" ||
                    !isOnlyIntegers(phoneNumber) ||
                    selectedTables.length === 0
                  ) {
                    setValidate(true);
                  }
                }}
              >
                Промени
              </Button>
            )}
          </div>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default EditReservationNewModal;
